import React from 'react';
import styled from '../../../../style/styled';
import { getPriceFormatted } from '../../../../utils/getPriceFormatted';
import { ContentSectionWidgetNewPrice } from './ContentSectionWidgetNewPrice';
import { CurrencyCode } from '../../../../graphql/globalTypes';
import { useSelector } from 'react-redux';
import { selectPromoCodeDiscountRate } from '../../../../store/app/selectors';
import { getTotalAmount } from '../../../../utils/getTotalAmount';

interface Props {
  currencyCode: CurrencyCode;
  price: number;
  priceInCents: boolean;
}

export const TourWidgetNewPrice: React.FC<Props> = ({
  currencyCode,
  price,
  priceInCents,
}) => {
  const discountRate = useSelector(selectPromoCodeDiscountRate);

  const originalPrice = getPriceFormatted({
    currencyCode,
    price,
    priceInCents,
  });

  const discountedPrice =
    discountRate > 0
      ? getPriceFormatted({
          currencyCode,
          priceInCents: false,
          price: getTotalAmount([
            {
              currencyCode,
              unitPrice: priceInCents ? price : Math.floor(price * 100),
              count: 1,
              discountRate,
            },
          ]),
        })
      : originalPrice;

  const priceIsDiscounted = Boolean(discountRate > 0 && price > 0);

  if (priceIsDiscounted) {
    return (
      <Container>
        <ContentSectionWidgetNewPrice
          strikeOut
          marginRight={8}
          color={'0066ff'}
          fontSize={22}
        >
          {originalPrice}
        </ContentSectionWidgetNewPrice>
        <ContentSectionWidgetNewPrice color={'0066ff'} fontSize={22}>
          {discountedPrice}
        </ContentSectionWidgetNewPrice>
      </Container>
    );
  }

  return (
    <Container>
      <ContentSectionWidgetNewPrice color={'#0066ff'} fontSize={22}>
        {originalPrice}
      </ContentSectionWidgetNewPrice>
    </Container>
  );
};

const Container = styled.div`
  text-align: center;
  font-size: 22px;
  cursor: default;
`;
